var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChronoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.011,
    height: 25,
    viewBox: "0 0 75.011 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M408.661,321.781l.761-.812c-2.1,0-4.292.088-6.56.27l-.391.935c2.139-.227,4.213-.356,6.19-.393",
    transform: "translate(-355.35 -320.969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M478.588,404.926a42.564,42.564,0,0,1-6.461,2.91l3.83,1.162a39.065,39.065,0,0,0,6.813-3.677Z",
    transform: "translate(-412.854 -390.279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M433.691,426.346c-1.629.51-3.351.977-5.15,1.39l2.546,2.018c2.161-.594,4.207-1.253,6.111-1.961Z",
    transform: "translate(-376.872 -407.962)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.746,323.019l1.317-.651a49.426,49.426,0,0,0-8.231-1.008l-.907.761a42.335,42.335,0,0,1,7.82.9",
    transform: "translate(-398.654 -321.292)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.544,370.493c-.58,1.543-2.069,3.112-4.269,4.6l4.114.182c2-1.7,3.2-3.461,3.4-5.167Z",
    transform: "translate(-451.776 -361.534)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M515.205,332.622l1.877-.6a19,19,0,0,0-3.725-1.519l-1.476.63a14.228,14.228,0,0,1,3.324,1.489",
    transform: "translate(-445.672 -328.84)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M541.859,347.725a5.344,5.344,0,0,0-2.173-3.258l-2.118.582a4.11,4.11,0,0,1,1.312,2.35,3.527,3.527,0,0,1,.026.787Z",
    transform: "translate(-466.878 -340.367)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.444,366.7l-.056.269a3.723,3.723,0,0,1-1.368,2.6,4.685,4.685,0,0,1-2.987.671c-2.441,0-4.2-.123-3.5-3.468l.493-2.368c.63-3.029,2.312-3.468,4.945-3.468,2.465,0,3.56.256,3.036,3l-.074.355h-2.464l.073-.355c.088-.818-.463-.878-1.276-.878-1.364,0-1.585.427-1.857,1.733l-.3,1.429c-.283,1.367-.333,1.893,1.1,1.893.993,0,1.487-.074,1.711-1.148l.055-.269Z",
    transform: "translate(-132.378 -353.965)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.169,370.514h-2.392l.747-3.59H189.4l-.746,3.59H186.26l1.906-9.157h2.393l-.717,3.442h3.123l.717-3.442h2.393Z",
    transform: "translate(-176.86 -354.311)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.861,361.359h4.618c2.063.036,2.986.488,2.511,2.771-.318,1.527-.5,2.418-2.286,2.82l-.02.1a1.207,1.207,0,0,1,1.278,1.625l-.383,1.843h-2.393l.267-1.282c.165-.683-.025-1.148-.743-1.148h-1.855l-.505,2.43h-2.393Zm3.29,4.6c1.028,0,1.075-.391,1.29-1.428.17-.819.016-1.05-.774-1.05h-1.855l-.516,2.478Z",
    transform: "translate(-225.315 -354.312)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M302.676,366.882l.539-2.588c.587-2.82,2.422-3.358,4.851-3.358s4.039.538,3.453,3.358l-.539,2.588c-.587,2.82-2.421,3.358-4.851,3.358s-4.04-.538-3.453-3.358m5.895-.269L309,364.55c.281-1.355-.133-1.489-1.377-1.489s-1.68.134-2,1.489l-.429,2.063c-.249,1.368.131,1.5,1.376,1.5s1.714-.134,2-1.5",
    transform: "translate(-272.865 -353.963)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.9,370.514H358.51l1.905-9.157h4.045l1.108,7.033h.1l1.319-7.033h2.393l-1.905,9.157h-4.081l-1.073-7.032h-.1Z",
    transform: "translate(-319.058 -354.311)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M424.8,366.882l.539-2.588c.587-2.82,2.422-3.358,4.85-3.358s4.041.538,3.453,3.358l-.538,2.588c-.587,2.82-2.422,3.358-4.852,3.358s-4.04-.538-3.453-3.358m5.9-.269.428-2.063c.282-1.355-.133-1.489-1.377-1.489s-1.679.134-2,1.489l-.43,2.063c-.249,1.368.13,1.5,1.375,1.5s1.715-.134,2-1.5",
    transform: "translate(-373.684 -353.963)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M280.94,328.865a70.517,70.517,0,0,1,13.213-3.319c.205-.032.41-.062.614-.093l.143-.995q-1.661.2-3.358.46a84.359,84.359,0,0,0-15.737,3.946Z",
    transform: "translate(-250.792 -323.85)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.186,427.577q-1.383.266-2.812.489c-12.095,1.878-22.758.7-26.873-2.587h-9.243c1.909,5.833,16.766,8.386,34.073,5.7,2.336-.362,4.6-.8,6.772-1.309Z",
    transform: "translate(-180.16 -407.245)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronoWhite);
export default __webpack_public_path__ + "static/media/chrono-white.ce6831d1.svg";
export { ForwardRef as ReactComponent };